<template>
  <v-row
    no-gutters
    class="shop-eyecatch mx-n3 mb-12"
  >
    <v-col
      cols="12" md="4"
      align-self="center"
      class="pa-6"
    >
      <p class="subtitle-2">Web で簡単。レンタカー予約。</p>
      <h1>
        <span class="d-block headline">ネッツトヨタ福岡</span>
        <span class="d-block subtitle-1">{{profile.name}}</span>
      </h1>
    </v-col>
    <v-col
      cols="12" md="8"
      v-if="profile.image"
    >
      <v-img
        :src="profile.image"
        :aspect-ratio="16/9"
      />
    </v-col>
  </v-row>
</template>

<style lang="scss">
@import '@/libs/vuetify/styles/variables.scss';

.shop-eyecatch {
  background-color: $key-color;
  color: $title-white-text-color;

  h1 > span {
    color: $title-white-text-color;
  }
}

</style>

<script>
export default {
  name: 'ShopEyecatch',
  props: {
    profile: {
      type: Object,
      required: true
    }
  }
}
</script>
